import { LegalLink } from "../../mobile/premiumCalcalistPaywallMobile";
import { HyperLinkBuilder } from "../../../../../commonComponents/inline/hyperLink";
import { PremiumPaywallSignModes, PaywallAuthErrorCodes } from "../../../../../../global/paywall/paywallInterfaces";
import { useState } from "react";

interface PremiumPayWallMobileSignupConfirmTermsProps {
  resetAuth: () => void
  thirdPartyLogin: (isNewCustomer: boolean) => void
  legalLinks: { terms: LegalLink; privacy: LegalLink };
}

export const PremiumPayWallMobileSignupConfirmTerms = (props: PremiumPayWallMobileSignupConfirmTermsProps) => {

  const { resetAuth, thirdPartyLogin, legalLinks } = props
  const [agreesTerms, setAgreesTerms] = useState(false)
  const [authError, setAuthError] = useState<string | null>(null)


  const handleAgreeChange = (e) => {
    setAgreesTerms(e.target.checked)
    setAuthError(null)
  }

  const errorMessagesFront: Partial<Record<PaywallAuthErrorCodes, string>> = {
    [PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT]: `חובה לאשר את תנאי השימוש`,
  };


  const handleContinue = () => {
    if (!agreesTerms) {
      setAuthError(PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT)
      return;
    }
    thirdPartyLogin(true)
  }

  return (
    <div className="premium-calcalist-paywall-mobile-signup-confirm-terms">
      <div className="digital-edition-label">המהדורה הדיגיטלית</div>
      <div className="title">
        שלב אחרון
      <br />
        לפני התחברות</div>
      <div className={`terms ${authError && authError === PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT ? 'error' : ''}`}>
        <div className="inner-container">
          <input type="checkbox" checked={agreesTerms} onChange={handleAgreeChange} />
          <span className="text">מסכים/ה ל<HyperLinkBuilder linkTarget={legalLinks.terms.target} href={legalLinks.terms.url}>תנאי השימוש</HyperLinkBuilder>, <HyperLinkBuilder linkTarget={legalLinks.privacy.target} href={legalLinks.privacy.url}>מדיניות פרטיות</HyperLinkBuilder>, וקבלת פניות שיווקיות כולל טלפוניות.הודעות תפעוליות ימשיכו להישלח בתקופת המנוי גם לאחר הסרתי מרשימת מדוורים.</span>
        </div>
        {authError && authError === PaywallAuthErrorCodes.SIGNUP_NO_AGREEMENT && <p className="error-text" dangerouslySetInnerHTML={{ __html: errorMessagesFront[authError] }}></p>}
      </div>
      <button className="button-base continue" onClick={handleContinue}>המשך</button>

      <div className="back-button">
        חזרה<button onClick={() => resetAuth()}>לכניסה</button>
      </div>
    </div>
  )
}
